module.exports = __webpack_public_path__ + "img/sol.92ff4fc0.png";